import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the viewer asked the system to cut down on animation. Follows the setting while the
 * page is open, so turning it on mid-session takes effect without a reload.
 */
export const usePrefersReducedMotion = (): boolean => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(
        () => window.matchMedia?.(QUERY).matches ?? false,
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia?.(QUERY);
        if (!mediaQuery) {
            return;
        }

        const handleChange = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches);

        setPrefersReducedMotion(mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return prefersReducedMotion;
};
